// import Header from "../../../../Components/Header";
// import AssemblyConsolidatedComponent from "./Components/AssemblyConsolidated-Components";
// import Footer from "../../../../Components/Footer";

import Header from "../../../Components/Header";
import Lpntable from './Components/Lpn-table'

const ApiLogTrack = () => {
  return (
    <div className='d-flex flex-column' style={{minHeight:'100vh'}}>
      <Header />
             <Lpntable />

    </div>
  );
};
export default ApiLogTrack;
